module.exports = __webpack_public_path__ + "static/img/background.73952056.svg";